import React, { FC } from "react";
import styles from "./BreadCrumbNav.module.scss";
import { BreadCrumSeparator } from "../../../assets/icon/IconCollection";

interface BreadCrumbNavProps {
  breadcrumbs: string[];
}

let BreadCrumbNav: FC<BreadCrumbNavProps> = (props) => {
  const { breadcrumbs } = props;

  if(breadcrumbs[breadcrumbs.length - 1] === "Login") {
    breadcrumbs.pop();
  }
  console.log("BreadCrumbNav", breadcrumbs);
  return (
    <div className={styles.breadcrumb}>
      {breadcrumbs.map((nav, index) => {
        return (
          <React.Fragment key={nav}>
            {
              <span
                className={
                  index === breadcrumbs.length - 1 ? styles.active : ""
                }
              >
                {nav}
              </span>
            }
            {index !== breadcrumbs.length - 1 && (
              <span className={styles.seperator} data-testid="2fd0e42b-45ef-4ad1-8601-6d63218288b8">
                <BreadCrumSeparator />
              </span>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

BreadCrumbNav = React.memo(BreadCrumbNav);

export default BreadCrumbNav;
